// src/poker/table/DealerControls.js
import React from "react";

export default function DealerControls({ isDealer, dealerNext, onLobby }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      <button className="btn btn-secondary" onClick={onLobby}>
        Lobby
      </button>

      {isDealer ? (
        <button
          className="btn btn-primary"
          disabled={dealerNext.disabled}
          onClick={() => {
            console.log("[UI] DealerControls click:", dealerNext?.label, "disabled=", dealerNext?.disabled);
            dealerNext.onClick?.();
          }}
          title={dealerNext.disabled ? "Najpierw zakończ licytację (wszyscy muszą wyrównać / spasować)." : ""}
          style={dealerNext.disabled ? { opacity: 0.55, cursor: "not-allowed" } : undefined}
        >
          {dealerNext.label}
        </button>
      ) : (
        <button className="btn btn-primary" disabled title="Tylko dealer może sterować ulicami" style={{ opacity: 0.55 }}>
          Dealer steruje
        </button>
      )}
    </div>
  );
}
